import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ConfirmUser from "./pages/email/ConfirmUser";
import ForgotPassword from "./pages/email/ForgotPassword";

function App() {
  return (
    <Router basename="/account">
      <Routes>
        <Route path="/confirmUser*" element={<ConfirmUser />} />
        <Route path="/forgotPassword" element={<ForgotPassword />} />
        <Route path="/" element={<div></div>} />
      </Routes>
    </Router>
  );
}

export default App;
